import React from "react";
import Webservice from "../../features/reports/admin/webservice/components/Webservice";

const _AdminWebService = () => {
  return (
    <div>
      <Webservice />
    </div>
  );
};

export default _AdminWebService;
